import { storeAuthorizedDSPsAction, storeAuthorizedEntitiesAction, storeAuthorizedLpsAction, storeAuthorizedLpSelectedAction } from "../../actions/lps/actions";
export var authorizationDispatch = function(clwsDispatch) {
    return {
        dispatchGetAuthorizedEntities: function(payload) {
            return clwsDispatch(storeAuthorizedEntitiesAction(payload));
        },
        dispatchGetAuthorizedLps: function(payload) {
            return clwsDispatch(storeAuthorizedLpsAction(payload));
        },
        dispatchGetAuthorizedDSPs: function(payload) {
            return clwsDispatch(storeAuthorizedDSPsAction(payload));
        },
        dispatchGetLPDetails: function(payload) {
            return clwsDispatch(storeAuthorizedLpSelectedAction(payload));
        }
    };
};
export default authorizationDispatch;

//# sourceMappingURL=authorisationDispatch.js.map